import { getSupabaseUrl } from '../supabase/client';

function processImageUrl(src: string): string {
  if (!src) return '';
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('/storage/')) return `${getSupabaseUrl()}${src}`;
  if (src.startsWith('/sb-api/')) return src;
  return src;
}

export function processQuestionHtml(html: string, imageWidths?: number[]): string {
  if (!html) return html;

  let processed = html
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#10;/g, '\n')
    .replace(/&amp;/g, '&');

  processed = processed.replace(/<img([^>]+)src="([^"]+)"([^>]*)>/g, (match, before, src, after) => {
    const fullSrc = processImageUrl(src);
    return `<img${before}src="${fullSrc}"${after}>`;
  });

  processed = processed.replace(/<img([^>]+)src='([^']+)'([^>]*)>/g, (match, before, src, after) => {
    const fullSrc = processImageUrl(src);
    return `<img${before}src="${fullSrc}"${after}>`;
  });

  if (imageWidths && imageWidths.length > 0) {
    let imgIndex = 0;
    processed = processed.replace(/<img([^>]*?)>/g, (match, attrs) => {
      const width = imgIndex < imageWidths.length ? imageWidths[imgIndex] : 100;
      imgIndex++;
      if (attrs.includes('style="')) {
        return match.replace(/style="([^"]*)"/, (m, styleContent) => {
          let newStyle = styleContent
            .replace(/display:\s*block;?\s*/gi, 'display:inline-block;')
            .replace(/(?<!max-)width:\s*\d+%;?\s*/g, '')
            .replace(/margin:\s*\d+px\s+\d+;?\s*/g, '')
            .replace(/margin-top:\s*\d+px;?\s*/g, '')
            .replace(/margin-bottom:\s*\d+px;?\s*/g, '');
          return `style="display:inline-block;width:${width}%;vertical-align:middle;margin:4px;${newStyle}"`;
        });
      }
      return `<img${attrs} style="display:inline-block;width:${width}%;vertical-align:middle;margin:4px;">`;
    });
  } else {
    processed = processed.replace(/<img([^>]*?)>/g, (match, attrs) => {
      if (attrs.includes('style="')) {
        return match.replace(/style="([^"]*)"/, (m, styleContent) => {
          let newStyle = styleContent
            .replace(/display:\s*block;?\s*/gi, 'display:inline-block;')
            .replace(/margin:\s*\d+px\s+\d+;?\s*/g, '')
            .replace(/margin-top:\s*\d+px;?\s*/g, '')
            .replace(/margin-bottom:\s*\d+px;?\s*/g, '');
          if (!newStyle.includes('display:')) {
            newStyle = `display:inline-block;${newStyle}`;
          }
          if (!newStyle.includes('vertical-align:')) {
            newStyle = `${newStyle}vertical-align:middle;`;
          }
          if (!newStyle.includes('margin')) {
            newStyle = `${newStyle}margin:4px;`;
          }
          return `style="${newStyle}"`;
        });
      }
      return `<img${attrs} style="display:inline-block;vertical-align:middle;margin:4px;">`;
    });
  }

  processed = processed.replace(/<p([^>]*?)>/g, (match, attrs) => {
    if (attrs.includes('style="')) {
      return match.replace(/style="([^"]*)"/, (m, styleContent) => {
        return `style="display:flex;flex-wrap:wrap;align-items:center;gap:4px;${styleContent}"`;
      });
    }
    return `<p${attrs} style="display:flex;flex-wrap:wrap;align-items:center;gap:4px;">`;
  });

  return processed;
}

export function getImageUrl(img: string | undefined): string {
  if (!img) return '';
  if (img.startsWith('/sb-api/')) return img;
  if (img.startsWith('/storage/')) return `${getSupabaseUrl()}${img}`;
  return img;
}